var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "messageCenter",
      attrs: { visible: _vm.showMessageCenter, width: "800px" },
      on: {
        "update:visible": function ($event) {
          _vm.showMessageCenter = $event
        },
        close: function ($event) {
          return _vm.$emit("messageCenterClose")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "messageCenter" },
        [
          _c("div", { staticClass: "header" }, [
            _c("div", { staticClass: "header-left" }, [
              _c("h1", [
                _c("i", { staticClass: "fas fa-envelope" }),
                _vm._v(" 消息中心"),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "tab-switcher" }, [
              _c(
                "button",
                {
                  class: ["tab-btn", { active: _vm.activeTab === "chat" }],
                  on: {
                    click: function ($event) {
                      return _vm.changeTab("chat")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fas fa-comments" }),
                  _vm._v(" 用户沟通 "),
                  _vm.unreadChatCount > 0
                    ? _c("span", { staticClass: "badge" }, [
                        _vm._v(_vm._s(_vm.unreadChatCount)),
                      ])
                    : _vm._e(),
                ]
              ),
              _c(
                "button",
                {
                  class: [
                    "tab-btn",
                    { active: _vm.activeTab === "notification" },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.changeTab("notification")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fas fa-bell" }),
                  _vm._v(" 系统通知 "),
                  _vm.unreadNotificationCount > 0
                    ? _c("span", { staticClass: "badge" }, [
                        _vm._v(_vm._s(_vm.unreadNotificationCount)),
                      ])
                    : _vm._e(),
                ]
              ),
            ]),
            _c(
              "div",
              { staticClass: "tab-content" },
              [
                _vm.activeTab === "chat"
                  ? _c("ChatList", {
                      ref: "chatList",
                      on: { "open-chat": _vm.openChatModal },
                    })
                  : _vm._e(),
                _vm.activeTab === "notification"
                  ? _c("NotificationList", {
                      ref: "notificationList",
                      on: {
                        closePopup: function ($event) {
                          _vm.showMessageCenter = false
                        },
                        refreshInformation: function ($event) {
                          ;(_vm.unreadNotificationCount = 0),
                            _vm.$emit("refreshNumber")
                        },
                        refreshNumber: function ($event) {
                          ;(_vm.unreadNotificationCount -= 1),
                            _vm.$emit("refreshNumber")
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c("ChatModal", {
            attrs: { show: _vm.showChatModal, "user-info": _vm.currentChat },
            on: { close: _vm.closeChatModal },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }